/**
 * User-reported concerns ("What isn't going well right now?"), mirrors
 * src/constants/zeovitConcerns.ts of the backend. Kept out of the API service module
 * so tests that mock the service still get the real values.
 */
export const ZEOVIT_CONCERNS = [
  'weak_blues',
  'weak_greens',
  'weak_reds_pinks',
  'weak_yellows',
  'purple_weak',
  'pale_white',
  'too_pastel',
  'brown_dark',
  'poor_polyp_extension',
  'slow_growth',
  'tissue_loss',
  'burnt_tips',
  'cyano',
  'dinos',
  'algae',
  'bacterial_film_cloudy',
] as const;

export type ZeovitConcern = (typeof ZEOVIT_CONCERNS)[number];

/** Maximum length of the free-text concern note (backend MAX_CONCERN_NOTE_LENGTH). */
export const ZEOVIT_CONCERN_NOTE_MAX = 1000;

/** Error code of the 409 answered when the aquarium has no volume (doses are per litre). */
export const AQUARIUM_VOLUME_REQUIRED_CODE = 'AQUARIUM_VOLUME_REQUIRED';
